import { Controller } from '@hotwired/stimulus';

/**
 * Two-level (city -> club) dropdown. Keeps a hidden native <select> in sync
 * so club-controller's `change` listener (reading select.value) needs no
 * changes.
 */
export default class extends Controller {
	static get targets () {
		return ['trigger', 'triggerLabel', 'panel'];
	}

	connect() {
        this.selectEl = this.element.querySelector('select');

		this.onOutsideClick = this.onOutsideClick.bind(this);
		document.addEventListener('click', this.onOutsideClick);
	}

	disconnect() {
		document.removeEventListener('click', this.onOutsideClick);
	}

	toggle() {
		this.setOpen(this.panelTarget.hidden);
	}

	setOpen(open) {
		this.panelTarget.hidden = !open;
		this.element.classList.toggle('is-open', open);
	}

	toggleCity(event) {
		const city = event.currentTarget.closest('.club-selection-dropdown__city');
		const expand = !city.classList.contains('is-expanded');

		this.element.querySelectorAll('.club-selection-dropdown__city').forEach(otherCity => {
			otherCity.classList.toggle('is-expanded', otherCity === city && expand);
		});
	}

	select(event) {
		const button = event.currentTarget;
		const value = button.dataset.value;

		this.element.querySelectorAll('.club-selection-dropdown__club').forEach(club => {
			club.classList.toggle('is-selected', club === button.closest('.club-selection-dropdown__club'));
		});

		this.triggerLabelTarget.textContent = button.querySelector('.club-selection-dropdown__club-name').textContent;

		if (this.selectEl && this.selectEl.value !== value) {
			this.selectEl.value = value;
			this.selectEl.dispatchEvent(new Event('change', { bubbles: true }));
		}

		this.dispatch('change', { detail: { clubId: value } });
		this.setOpen(false);
	}

	onOutsideClick(event) {
		if (!this.element.contains(event.target)) {
			this.setOpen(false);
		}
	}
}
